import { FC } from "react";
import Icon from "~/components/Icon";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import { Coupon } from "~/services/coupon";
import styles from "./CouponItem.module.scss";
import { REMOVE_COUPON_CODE, useCart } from "~/data/cart";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useRecoilState, useRecoilValue } from "recoil";
import { Cart, CartAtom } from "~/services/cart";

interface CouponItemProps {
  coupon: string;
  handleRemove: (id: string) => void;
}

const CouponItem: FC<CouponItemProps> = ({ coupon, handleRemove }) => {
  const cartSelector = useRecoilValue(CartAtom.cartSelector)

  const {removeCouponCode , loadingRemoveCouponCode} = useCart()
  
  const handleRemoveCoupon = () => {
    removeCouponCode({
      variables:{
        cartId: cartSelector.cartId,
      }
    })
  };

  return (
    <div className={styles.coupon_item}>
      <Icon name="ticket-discount" color={Colors.ACCENT_BLUE_50} size={20} />
      <Text
        className="!leading-none"
        type="label-5"
        color={Colors.ACCENT_BLUE_50}
      >
        {coupon}
      </Text>
      {loadingRemoveCouponCode ? <Icon
        name="status"
        className="animate-spin"
        size={20}
        color={Colors.GREY_300}
      />:
        <Icon
        name="close"
        className="cursor-pointer"
        size={20}
        color={Colors.GREY_300}
        onClick={handleRemoveCoupon}
      />
      }
    </div>
  );
};

export default CouponItem;
